/* eslint-disable camelcase */
import { createContext } from 'react';

import { TLink } from '../types.d';

export const context = createContext<{
  linkMap: Record<string, TLink>;
}>(undefined as any);
